export const EMPLOYEES = 'employee@allEmployee';
export const BRANCHES = 'employee@allBranches';
export const DEPARTMENTS = 'employee@allDepartments';
export const DESIGNATIONS = 'employee@allDesignations';
export const EMPLOYEE_CATEGORIES = 'employee@allEmployeeCategories';
export const GENDERS = 'employee@allGenders';
export const SHIFTS = 'employee@allShifts';

export default {
    [EMPLOYEES]: {
        url: 'employee/get/all',
    },
    [BRANCHES]: {
        url: 'branch/get/all',
    },
    [DEPARTMENTS]: {
        url: 'department/get/all',
    },
    [DESIGNATIONS]: {
        url: 'designation/all',
    },
    [EMPLOYEE_CATEGORIES]: {
        url: 'employee-category/get/all',
    },
    [GENDERS]: {
        url: 'genders',
    },
    [SHIFTS]: {
        url: 'shift/get/all',
    }
};
